export default {
  title: 'Historial de edición del menú',
  subtitle: 'Consulta quién cambió precios, disponibilidad y visibilidad de {{company}}, y cuándo.',
  filters: {
    type: {
      label: 'Tipo',
    },
    item: {
      placeholder: 'Todos los elementos',
    },
    event: {
      label: 'Evento',
    },
  },
  columns: {
    when: 'Cuándo',
    who: 'Modificado por',
    type: 'Tipo',
    item: 'Elemento',
    event: 'Evento',
    changes: 'Cambios',
  },
  types: {
    product: 'Producto',
    modifier: 'Modificador',
  },
  events: {
    created: 'Creado',
    updated: 'Actualizado',
    deleted: 'Eliminado',
  },
  fields: {
    name: 'Nombre',
    description: 'Descripción',
    price: 'Precio',
    is_available: 'Disponibilidad',
    is_visible: 'Visibilidad',
    is_available_for_pickup: 'Disponibilidad para recogida',
    is_available_for_delivery: 'Disponibilidad para entrega',
  },
  booleans: {
    on: 'Disponible',
    off: 'No disponible',
  },
  pagination: {
    previous: 'Anterior',
    next: 'Siguiente',
  },
  causers: {
    orders_terminal: 'Terminal de pedidos',
  },
  system: 'Sistema',
  empty_value: '—',
  toasts: {
    failed_to_load_data: 'Error al cargar el historial de edición del menú',
  },
};
